import styled from '@emotion/styled';
import {
  Typography,
  Modal as MuiModal,
  CircularProgress,
} from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const StyledCircularProgress = styled(CircularProgress)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  color: theme.colors.paletteFromBO.main,
}));

export const Modal = styled(MuiModal)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const Container = styled.div<Theme>(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  border: 'none',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  boxSizing: 'border-box',
  color: theme.colors.grey.dark,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(10, 21),
  textAlign: 'center',
  width: 800,
  ':focus': {
    outline: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'flex-start',
    maxHeight: '100vh',
    overflow: 'auto',
    padding: '7.5vw',
    width: '100%',
  },
}));

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(3),
  color: theme.colors.paletteFromBO.main,
}));

export const Description = styled(Typography)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const ButtonsContainer = styled.div<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  width: '100%',
}));

export const ErrorMessage = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.error.main,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}));
